'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _utilsAccessibility = require('@bibliocommons/utils-accessibility');

var _expandButton = require('../../expand-button');

var _expandButton2 = _interopRequireDefault(_expandButton);

require('../styles/ExpandablePanel.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandablePanel = function (_BcReactComponent) {
  _inherits(ExpandablePanel, _BcReactComponent);

  function ExpandablePanel(props) {
    _classCallCheck(this, ExpandablePanel);

    var _this = _possibleConstructorReturn(this, (ExpandablePanel.__proto__ || Object.getPrototypeOf(ExpandablePanel)).call(this, props));

    _this.state = {
      expanded: false
    };
    _this.bindAll('handleToggle', 'renderHeading', 'renderBodyContent');
    _this.contentRef = null;
    return _this;
  }

  _createClass(ExpandablePanel, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.expanded && this.state.expanded && this.contentRef) {
        (0, _utilsAccessibility.setFocusWithinElement)(this.contentRef);
      }
    }
  }, {
    key: 'handleToggle',
    value: function handleToggle() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'renderExpandButton',
    value: function renderExpandButton() {
      var renderExpandButtonLabel = this.props.renderExpandButtonLabel;


      return _react2.default.createElement(_expandButton2.default, { handleToggle: this.handleToggle, expanded: this.state.expanded, renderLabel: renderExpandButtonLabel });
    }
  }, {
    key: 'renderHeading',
    value: function renderHeading() {
      return _react2.default.createElement(
        'div',
        { className: 'panel-heading' },
        this.props.renderHeaderContent(),
        this.renderExpandButton()
      );
    }
  }, {
    key: 'renderBodyContent',
    value: function renderBodyContent() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'panel-body', ref: function ref(el) {
            _this2.contentRef = el;
          } },
        this.props.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('cp-expandable-panel panel', className) },
        this.renderHeading(),
        this.state.expanded ? this.renderBodyContent() : null
      );
    }
  }]);

  return ExpandablePanel;
}(_baseBcReactComponent2.default);

exports.default = ExpandablePanel;


ExpandablePanel.propTypes = {
  className: _react.PropTypes.string,
  renderHeaderContent: _react.PropTypes.func,
  renderExpandButtonLabel: _react.PropTypes.func,
  renderBodyContent: _react.PropTypes.func,
  children: _bcPropTypes.childrenShape
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expandable-panel/components/ExpandablePanel.component.js
// module id = 1410
// module chunks = 1